import React, { useState } from "react";
import Confetti from "react-confetti";

const whiteNotes = ["C", "D", "E", "F", "G", "A", "B"];

// Estimated X positions for each white key (you can adjust as needed)
const notePositions = {
  C: "25%",
  D: "35%",
  E: "43%",
  F: "50%",
  G: "58%",
  A: "66%",
  B: "75%",
};

export default function FindTheNoteGame({ onComplete }) {
  const [foundNotes, setFoundNotes] = useState([]);
  const [showConfetti, setShowConfetti] = useState(false);

  const handleNoteClick = (note) => {
    if (foundNotes.includes(note)) return;

    if (whiteNotes.includes(note)) {
      const updated = [...foundNotes, note];
      setFoundNotes(updated);

      if (updated.length === whiteNotes.length) {
        setShowConfetti(true);
        setTimeout(() => {
          setShowConfetti(false);
          onComplete?.();
        }, 3000);
      }
    } else {
      alert("❌ Try again!");
    }
  };

  return (
    <div className="relative w-full max-w-4xl mx-auto text-center p-4 bg-white/90 rounded-xl shadow">
      {showConfetti && (
        <Confetti width={window.innerWidth} height={window.innerHeight} />
      )}

      <h2 className="text-xl font-bold text-purple-700 mb-2">🎯 Find the White Notes</h2>
      <p className="mb-4 text-gray-600">Click all the white keys on this piano</p>

      {/* 🎹 Piano Image */}
      <div className="relative">
        <img
          src="/images/Intro/keyboard-white-notes.png"
          alt="Full Piano"
          className="w-full max-h-[400px] object-contain border rounded-xl"
        />

        {/* 🎯 Aligned clickable note buttons */}
        {whiteNotes.map((note) => (
          <button
            key={note}
            onClick={() => handleNoteClick(note)}
            className={`absolute bottom-2 transform -translate-x-1/2 w-8 h-8 rounded-full text-xs font-bold transition
              ${foundNotes.includes(note) ? "bg-green-400 text-white" : "bg-white text-black"}
              shadow hover:scale-110`}
            style={{ left: notePositions[note] }}
          >
            {note}
          </button>
        ))}
      </div>

      {/* Progress */}
      <p className="mt-4 text-sm text-gray-700">
        ✅ You’ve found {foundNotes.length}/{whiteNotes.length} notes!
      </p>
    </div>
  );
}
